import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LogIn, ShieldAlert } from "lucide-react";
import { api, setToken } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await api("/auth/login", {
        method: "POST",
        auth: false,
        body: { email, password },
      });
      setToken(data.access_token);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(err.message || "Error de inicio de sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0908] flex items-center justify-center px-6">
      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        data-testid="admin-login-form"
        className="w-full max-w-md bg-[#12100E] border border-white/5 p-8 md:p-10 relative"
      >
        <div className="absolute -top-4 left-8 bg-[#0A0908] px-3">
          <span className="text-[0.65rem] uppercase tracking-[0.5em] text-[#C89B3C]">
            El Navegante · CRM
          </span>
        </div>
        <h1 className="font-serif text-3xl md:text-4xl font-black text-[#F5F0E6] mb-2">
          Ingresa al panel
        </h1>
        <p className="text-sm text-[#8A7D71] mb-8">
          Acceso exclusivo del propietario.
        </p>

        {error && (
          <div
            data-testid="login-error"
            className="mb-5 border border-red-500/30 bg-red-500/10 p-3 flex items-start gap-3 text-sm text-red-200"
          >
            <ShieldAlert size={18} className="shrink-0 mt-0.5" />
            <span>{error}</span>
          </div>
        )}

        <label className="block text-xs uppercase tracking-widest text-[#B8A99A] mb-2">
          Correo
        </label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="login-email"
          placeholder="owner@elnavegante.com"
          className="w-full bg-[#0A0908] border border-white/10 text-[#F5F0E6] focus:border-[#C89B3C] focus:ring-1 focus:ring-[#C89B3C] outline-none placeholder-[#5A4F45] py-3 px-4 mb-5 transition-colors"
        />

        <label className="block text-xs uppercase tracking-widest text-[#B8A99A] mb-2">
          Contraseña
        </label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="login-password"
          placeholder="••••••••"
          className="w-full bg-[#0A0908] border border-white/10 text-[#F5F0E6] focus:border-[#C89B3C] focus:ring-1 focus:ring-[#C89B3C] outline-none placeholder-[#5A4F45] py-3 px-4 mb-8 transition-colors"
        />

        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit"
          className="w-full flex items-center justify-center gap-2 bg-[#A66E38] hover:bg-[#B88655] disabled:opacity-50 text-[#F5F0E6] uppercase tracking-[0.3em] text-xs py-4 px-8 transition-colors duration-300"
        >
          {loading ? "Ingresando..." : (<><LogIn size={16} /> Entrar</>)}
        </button>

        <a
          href="/"
          data-testid="login-back-home"
          className="block text-center mt-6 text-xs uppercase tracking-widest text-[#8A7D71] hover:text-[#C89B3C] transition-colors"
        >
          ← Volver al sitio
        </a>
      </motion.form>
    </div>
  );
}
